(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('CommunicationSubscriptionDialogController', CommunicationSubscriptionDialogController);

    CommunicationSubscriptionDialogController.$inject = ['$uibModalInstance', 'entity', 'Contrat', 'CommunicationTopic', 'Principal', 'AlertService'];

    function CommunicationSubscriptionDialogController($uibModalInstance, entity, Contrat, CommunicationTopic, Principal, AlertService) {
        var vm = this;

        vm.subscription = angular.copy(entity);
        vm.communicationTopics = [];
        vm.availableCommunicationTopics = [];
        vm.existingSubscriptions = [];
        vm.contrat = null;
        vm.contactAlertKey = null;
        vm.duplicateAlertKey = null;
        vm.isSaving = false;
        vm.clear = clear;
        vm.onTopicChange = onTopicChange;
        vm.save = save;

        Principal.identity().then(function(account) {
            if (account && account.agence && account.agence.id) {
                vm.communicationTopics = CommunicationTopic.byAgence({agenceId: account.agence.id}, function() {
                    refreshAvailableTopics();
                    refreshContactAlert();
                });
            }
        });

        if (vm.subscription.contratId) {
            vm.contrat = Contrat.get({id: vm.subscription.contratId}, function() {
                refreshContactAlert();
            });
            Contrat.getCommunicationSubscriptions({idContrat: vm.subscription.contratId}, function(result) {
                vm.existingSubscriptions = result || [];
                refreshAvailableTopics();
                refreshContactAlert();
            });
        }

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            onTopicChange();
            if (vm.duplicateAlertKey) {
                AlertService.error(vm.duplicateAlertKey);
                return;
            }
            if (vm.contactAlertKey) {
                AlertService.warning(vm.contactAlertKey);
            }
            vm.isSaving = true;
            Contrat.addCommunicationSubscription(vm.subscription, onSaveSuccess, onSaveError);
        }

        function onTopicChange() {
            refreshAvailableTopics();
            refreshContactAlert();
        }

        function refreshContactAlert() {
            var selectedTopic;

            vm.contactAlertKey = null;
            vm.duplicateAlertKey = null;
            if (!vm.subscription || !vm.subscription.communicationTopicId || !vm.communicationTopics.length || !vm.contrat) {
                return;
            }

            if (isTopicAlreadySubscribed(vm.subscription.communicationTopicId)) {
                vm.duplicateAlertKey = 'error.business.communicationSubscription.duplicateTopic';
                return;
            }

            selectedTopic = vm.communicationTopics.find(function(topic) {
                return String(topic.id) === String(vm.subscription.communicationTopicId);
            });

            if (!selectedTopic || !selectedTopic.contractContact) {
                return;
            }

            if (selectedTopic.contractContact === 'PHONE' && !vm.contrat.phone) {
                vm.contactAlertKey = 'wamasysApp.contrat.communicationSubscription.missingPhoneWarning';
            } else if (selectedTopic.contractContact === 'EMAIL' && !vm.contrat.email) {
                vm.contactAlertKey = 'wamasysApp.contrat.communicationSubscription.missingEmailWarning';
            }
        }

        function refreshAvailableTopics() {
            if (!vm.communicationTopics || !vm.communicationTopics.length) {
                vm.availableCommunicationTopics = [];
                return;
            }

            vm.availableCommunicationTopics = vm.communicationTopics.filter(function(topic) {
                return !isTopicAlreadySubscribed(topic.id);
            });

            if (vm.subscription && vm.subscription.communicationTopicId && isTopicAlreadySubscribed(vm.subscription.communicationTopicId)) {
                vm.subscription.communicationTopicId = null;
            }
        }

        function isTopicAlreadySubscribed(topicId) {
            if (!topicId || !vm.existingSubscriptions || !vm.existingSubscriptions.length) {
                return false;
            }

            return vm.existingSubscriptions.some(function(subscription) {
                return String(subscription.communicationTopicId) === String(topicId);
            });
        }

        function onSaveSuccess(result) {
            vm.isSaving = false;
            $uibModalInstance.close(result);
        }

        function onSaveError() {
            vm.isSaving = false;
        }
    }
})();
